import { default as PopupComponent } from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const Popup = ({ childrenArray, width = 200, title = "Action", ...props }) => {
	return (
		<PopupComponent {...props} contentStyle={{ width }}>
			{childrenArray?.map((child, index) => {
				if (child === null) return null;
				if (child?.hasOwnProperty("childrenArray")) {
					return <Popup key={index} {...child} />;
				} else {
					return (
						<div className="popup-option" key={index} onClick={child?.onClick}>
							{child?.text}
						</div>
					);
				}
			})}
		</PopupComponent>
	);
};

export default Popup;
